import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dc4449e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "day-seat-info--detail" }
const _hoisted_2 = { class: "day-seat-info--wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "day-seat-info--label"
}
const _hoisted_4 = {
  key: 1,
  class: "day-seat-info--label"
}
const _hoisted_5 = { class: "day-seat-info--content-container" }
const _hoisted_6 = { class: "book--year-month" }
const _hoisted_7 = { class: "book-day-seat" }
const _hoisted_8 = { class: "book-day-seat-item--day" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "seat-info" }, " App의 좌석위치와 실제 버스의 좌석위치가 다를 수 있습니다. App에서 안내된 좌석위치에 탑승하여 주시기 바랍니다. ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.seatAssignYn)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "탑승일(좌석)"))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "탑승일")),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.monthlyBookDetailsMap, ([key, monthlyBookDetails], index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "day-seat-info--content",
            key: index
          }, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(key) + " (총 " + _toDisplayString(monthlyBookDetails.length) + "일) ", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlyBookDetails, (bookInfo, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["book-day-seat-item", {
                canceled:
                  !$props.isBookConfirmation &&
                  bookInfo.statusCode === $setup.BookStatusCode.CANCEL,
              }]),
                  key: index
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString($setup.dayjs(bookInfo.boardingDate).format("D")) + "일", 1 /* TEXT */),
                  ($props.seatAssignYn)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "("))
                    : _createCommentVNode("v-if", true),
                  ($props.seatAssignYn)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(["book-day-seat-item--seat", {
                  selected:
                    !!$setup.selectedBoardingDate &&
                    $setup.selectedBoardingDate.boardingDate === bookInfo.boardingDate,
                  canceled:
                    !$props.isBookConfirmation &&
                    bookInfo.statusCode === $setup.BookStatusCode.CANCEL,
                }]),
                        onClick: ($event: any) => ($setup.selectBoardingDate(bookInfo))
                      }, _toDisplayString(bookInfo.seatNo ?? "-"), 11 /* TEXT, CLASS, PROPS */, _hoisted_10))
                    : _createCommentVNode("v-if", true),
                  ($props.seatAssignYn)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, ")"))
                    : _createCommentVNode("v-if", true),
                  (index !== monthlyBookDetails.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, ","))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    ($props.seatAssignYn && $setup.seatsInfosList?.[$setup.mySeatFloor - 1]?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode($setup["SeatsLayout"], {
            currentFloor: $setup.mySeatFloor,
            totalFloor: $setup.seatsInfosList.length,
            seatsInfo: $setup.seatsInfosList[$setup.mySeatFloor - 1],
            numberOfRows: $setup.seatsRowsNumList?.[$setup.mySeatFloor - 1],
            numberOfColumns: $setup.seatsColumnsNumList?.[$setup.mySeatFloor - 1],
            mySeatNo: $setup.mySeatNo
          }, null, 8 /* PROPS */, ["currentFloor", "totalFloor", "seatsInfo", "numberOfRows", "numberOfColumns", "mySeatNo"]),
          _hoisted_14
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}